import { ReactElement } from "react";
import { FactoryIcon } from "lucide-react";

import {
  SheetCollapsibleIndustryOrSkillList,
  SheetSectionContainer,
  SheetSectionEmptyText,
  SheetSectionHeader,
} from "@/components";

import { Industry } from "@/types";

export const SheetIndustries = ({ industries }: { industries: Industry[] }) => {
  // Filter out industries without names.
  const filteredIndustries = industries.filter((industry) =>
    industry.name?.trim(),
  );

  const IndustriesSheetSectionContainerAndHeader = ({
    children,
    isEmpty,
  }: {
    children: ReactElement;
    isEmpty?: boolean;
  }) => {
    return (
      <SheetSectionContainer>
        <SheetSectionHeader
          icon={FactoryIcon}
          isEmpty={isEmpty}
          title="Industries"
        />
        {children}
      </SheetSectionContainer>
    );
  };

  if (!filteredIndustries.length) {
    return (
      <IndustriesSheetSectionContainerAndHeader isEmpty>
        <SheetSectionEmptyText text="This candidate hasn't added any industries yet." />
      </IndustriesSheetSectionContainerAndHeader>
    );
  }

  return (
    <IndustriesSheetSectionContainerAndHeader>
      <SheetCollapsibleIndustryOrSkillList
        industriesOrSkills={filteredIndustries}
      />
    </IndustriesSheetSectionContainerAndHeader>
  );
};
